import {
  formatNumber,
  formatShortDate,
  getTimezoneDate,
  timezones,
} from "../../utilities/helpers";

import Table from "react-bootstrap/Table";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";

export default function DailyTicketsCountReport({ data }) {
  return (
    <Card body className="card--md card-with-border">
      <Table>
        <thead>
          <tr>
            <th colSpan={2}>Event name</th>
            <th>Event date</th>
            <th>Event status</th>
            <th>Sold yesterday</th>
            <th>Sold today</th>
            <th>Total sold</th>
            <th>Comps</th>
            <th>Packages</th>
            <th>Total allocated</th>
            <th>Capacity</th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data.map((d, index) => (
              <tr key={index}>
                <td colSpan={2}>{d?.event?.name}</td>
                <td>
                  {formatShortDate(
                    getTimezoneDate(
                      d?.event?.start,
                      timezones(d?.event?.venue[0]?.timezone),
                    ),
                    "dateOnly",
                  )}
                </td>
                <td>
                  <div className="w-max-content m-auto">
                    <Badge bg="none" className="badge-sm badge--onsale">
                      On Sale
                    </Badge>
                  </div>
                </td>
                <td>{formatNumber(d?.soldYesterday)}</td>
                <td>{formatNumber(d?.soldToday)}</td>
                <td>{formatNumber(d?.totalSold)}</td>
                <td>{formatNumber(d?.comps)}</td>
                <td>{formatNumber(d?.package)}</td>
                <td>{formatNumber(d?.totalAllocated)}</td>
                <td>{formatNumber(d?.capacity)}</td>
              </tr>
            ))}
        </tbody>
      </Table>
    </Card>
  );
}
